import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import React, { Component } from 'react';
import './../../styles/global.scss';
import {translateSiteName} from "../../helpers/data-helpers";

export class MapComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  displayMarkers = () => {
   

    return this.props.sites.map((site, index) => {
      return <Marker key={index} id={index} 
      title={translateSiteName(site)}
   
      position={{
       lat: site.latitude,
       lng: site.longitude
     }}
     onClick={() => console.log("")} />
     
    })


  
  }

  render() {
    const mapStyles = {
      width: '100%',
      height: '100%',
    };
    return (
            <div className = "map">

              <Map
                google={this.props.google}
                zoom={6}
                style={mapStyles}
                initialCenter={{ lat: 54, lng: -4.2}}
                
              >
                {this.displayMarkers()}
                
 
              </Map>
          </div>

    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCZW5yOPF-dVT7GnT5OJfEYFsk4mqDgvTM'
})(MapComponent);